import React from 'react';
import styles from './DropDownResults.module.css';
import { MultiSelectDropDownOption } from './types';

interface OptionTextProps {
  option: MultiSelectDropDownOption;
}

const OptionText = ({ option }: OptionTextProps) => (
  <span className={styles.optionText}>
    {option.value} <span className={styles.optionId}>({option.id})</span>
  </span>
);

export default OptionText;
